import React, {useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import {formBodyType} from '../../../../../../util/uiconstants';
import {Filter, FilterConfiguration, FilterTypes} from '@ey/canvascoreservices';
import styled from 'styled-components';

const config = {
	[formBodyType.ISA315ScotItApplication]: {
		search: {
			label: 'search',
			type: FilterTypes.search,
			data: () => ({})
		},
		datepicker: {
			label: 'datepicker',
			type: FilterTypes.datepicker
		},
		boolean: {
			label: 'boolean',
			type: FilterTypes.boolean
		},
		string: {
			label: 'string',
			type: FilterTypes.string
		}
	}
	// [formBodyType.ISA315ItApplicationScot]: ,
	// [formBodyType.ISA315ItProcessItApplication]: ,
	// [formBodyType.ISA315ItProcessTask]:
};

const filterKey = 'filterKey';

const BodySpecialToolbarFilter = ({bodyTypeId, onFilterChange}) => {
	const filters = useMemo(() => new FilterConfiguration(filterKey, config[bodyTypeId]), [bodyTypeId]);

	const handleOnSetFilter = useCallback((filter, value) => {
		if (onFilterChange) {
			onFilterChange(filter, value);
		}
	}, []);

	const onDisableFilter = useCallback((filter, value) => {
		if (onFilterChange) {
			onFilterChange(filter, value);
		}
	}, []);

	return (
		<StyledBodySpecialToolbarFilter className="StyledBodySpecialToolbarFilter">
			<Filter
				// TODO:
				filterKey={filterKey}
				filters={filters}
				setState={() => {}}
				onEnableFilter={handleOnSetFilter}
				onDisableFilter={onDisableFilter}
			/>
		</StyledBodySpecialToolbarFilter>
	);
};

BodySpecialToolbarFilter.propTypes = {
	bodyTypeId: PropTypes.number.isRequired,
	onFilterChange: PropTypes.func
};

BodySpecialToolbarFilter.defaultProps = {};

export default BodySpecialToolbarFilter;

const StyledBodySpecialToolbarFilter = styled.section`
	.filter-container {
		button {
			border: unset;
		}
	}
`;
